import { ComponentPropsWithoutRef, forwardRef } from 'react';

import classNames from 'classnames';

import {
  getInputClassNames,
  FormGroup,
  SharedInputProps,
} from '@/components/FormElements';

export interface InputProps
  extends Omit<ComponentPropsWithoutRef<'input'>, 'id'>,
    SharedInputProps {}

export const Input = forwardRef<HTMLInputElement, InputProps>(
  (
    { displaySize = 'md', invalid, label, hideLabel, id, helpText, ...props },
    ref,
  ) => {
    const { value, onChange } = props;

    return (
      <FormGroup
        label={label}
        id={id}
        hideLabel={hideLabel}
        required={props.required}
        helpText={helpText}
      >
        <div
          className={classNames('relative grow flex items-center', {
            'gap-3': displaySize === 'md',
            'gap-4': displaySize === 'lg',
            'gap-5': displaySize === 'xl',
          })}
        >
          <input
            ref={ref}
            className={getInputClassNames({
              displaySize,
              invalid,
            })}
            value={value}
            onChange={onChange}
            id={id}
            {...props}
          />
        </div>
      </FormGroup>
    );
  },
);

Input.displayName = 'Input';
